import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { getTaxReceipts } from '@sola/proxy-sdk/utils/routes.ts';
import { QUERY_KEYS } from '../constants.ts';
import { useReadyForQueries } from './base.ts';

/**
 * Hook to fetch tax receipts.
 */
export const useTaxReceipts = () => {
  const $ = _c(6);
  const {
    isReady,
    globalId
  } = useReadyForQueries();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [QUERY_KEYS.supporterTaxReceipts];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== globalId) {
    t1 = () => getTaxReceipts(globalId);
    $[1] = globalId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isReady || $[4] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      refetchOnWindowFocus: false,
      enabled: isReady,
      staleTime: Infinity
    };
    $[3] = isReady;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return useQuery(t2);
};